import { z } from 'zod';
/** An organization is created with a name alone; everything else is configured afterwards. */
export const OrganizationCreateBodySchema = z.object({ name: z.string().min(1) }).strict();
/** The rename route. Required rather than optional: an empty body renames nothing. */
export const OrganizationUpdateBodySchema = z.object({ name: z.string().min(1) }).strict();
/**
 * The single sign-on settings, patched on their own route because they are admin-only. `slug` is
 * the identifier the login page resolves an organization by.
 */
export const OrganizationSsoUpdateBodySchema = z
    .object({
    slug: z.string().min(1).optional(),
    ssoEnabled: z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=upsert.js.map